import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingResourcePoolStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingResourcePoolStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingResourcePoolStore.onSearchJobAction({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    })
    marketingResourcePoolStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingResourcePoolStore.onGetStatus('marketType')
    marketingResourcePoolStore.onGetStatus('showType')
    marketingResourcePoolStore.getReportConditions()
  }

  handleSearch = () => {
    const {marketingResourcePoolStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketingGroupId': fieldsValue.marketingGroupId,
        'configName': fieldsValue.configName,
        'configTypeList': fieldsValue.configTypeList,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingResourcePoolStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {marketingResourcePoolStore, location, t, accountStore} = this.props
    const {groupList, statusList} = marketingResourcePoolStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="marketingGroupId" label={t(`marketingManagement.marketingGroup`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="configName" label={t(`marketingManagement.resourcePoolName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.resourcePoolName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="configTypeList" label={t(`marketingManagement.marketingClass`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {statusList?.map(item => (<Select.Option key={item?.code} value={item?.code}>{item?.name}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col flex="auto" style={{textAlign: 'right', marginBottom: 10}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              {isPowerUser ? <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button> : null}
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
